let time = null
const debounceEvent = (fn, timeout = 1000) => {
  clearInterval(time)
  time = setTimeout(() => {
    fn()
  }, timeout)
}

export default debounceEvent
